import { render, staticRenderFns } from "./uploadOpenDialog.vue?vue&type=template&id=b95b4b82&scoped=true&"
import script from "./uploadOpenDialog.vue?vue&type=script&lang=ts&"
export * from "./uploadOpenDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95b4b82",
  null
  
)

export default component.exports